import {
  Directive,
  effect,
  ElementRef,
  inject,
  input,
  InputSignal,
  OnDestroy,
  signal,
  WritableSignal,
} from '@angular/core';

@Directive({
  selector: '[appCounterEffect]',
})
export class CounterEffect implements OnDestroy {
  elementRef: ElementRef = inject(ElementRef);
  value: InputSignal<number> = input.required<number>({ alias: 'appCounterEffect' });
  transform: InputSignal<((value: number) => string | number) | undefined> =
    input<(value: number) => string | number>();
  animationDuration: number = 800;
  displayedValue: WritableSignal<number> = signal(0);
  tickCount: number = 4;

  private intervalId: ReturnType<typeof setInterval> | null = null;
  private previousValue: number = 0;

  constructor() {
    const element: HTMLElement = this.elementRef.nativeElement;

    effect(() => {
      const target: number = this.value();
      const start: number = this.previousValue;
      const difference: number = target - start;
      const gap: number = difference / this.tickCount;
      let tick: number = 0;

      if (this.intervalId !== null) clearInterval(this.intervalId);
      if (difference === 0) return;

      this.intervalId = setInterval(() => {
        tick++;
        const isLast: boolean = tick >= this.tickCount;
        this.displayedValue.set(isLast ? target : start + Math.round(gap * tick));

        if (isLast) {
          clearInterval(this.intervalId!);
          this.intervalId = null;
          this.previousValue = target;
        }
      }, this.animationDuration / this.tickCount);
    });

    effect(() => {
      const transformFn = this.transform();
      const val = this.displayedValue();
      element.textContent = String(transformFn ? transformFn(val) : val);
    });
  }

  ngOnDestroy(): void {
    if (this.intervalId !== null) clearInterval(this.intervalId);
  }
}
